import { useRef } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

const ALL_LOCATIONS = [
  { name: "Manchester", path: "/management/manchester/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/9f3ae319c_dinosaur-manchester-skyline-1186.webp" },
  { name: "Liverpool", path: "/management/liverpool/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/59d2a13ca_generated_image.png" },
  { name: "London", path: "/management/london/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/519f0a96a_7.jpg" },
  { name: "Birmingham", path: "/management/birmingham/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/e1ab964f2_generated_image.png" },
  { name: "Leeds", path: "/management/leeds/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/9feea35a2_generated_image.png" },
  { name: "Newcastle", path: "/management/newcastle/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/cb231aadc_generated_image.png" },
  { name: "Sheffield", path: "/management/sheffield/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/c71e0847e_generated_image.png" },
  { name: "Stoke-on-Trent", path: "/management/stoke-on-trent/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/7b53d04b6_StreoAd-260x2004.jpg" },
  { name: "Chester", path: "/management/chester/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/f359685c2_ThumbnailFeaturedImages1.jpg" },
  { name: "Stockport", path: "/management/stockport/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/870370e5d_generated_image.png" },
  { name: "Brighton", path: "/management/brighton/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/66e8e9486_generated_image.png" },
  { name: "Essex", path: "/management/essex/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/2368d4f28_generated_image.png" },
  { name: "Oxford", path: "/management/oxford/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/7675b4d3d_generated_image.png" },
  { name: "Bath", path: "/management/bath/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/6e95de0d6_generated_image.png" },
  { name: "Slough", path: "/management/slough/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/4134daee7_generated_image.png" },
  { name: "Southampton", path: "/management/southampton/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/4b82e625c_generated_image.png" },
  { name: "Stoke-on-Trent", path: "/management/stoke-on-trent/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/7b53d04b6_StreoAd-260x2004.jpg" },
];

export default function LocationsCarousel({ currentLocation }) {
  const trackRef = useRef(null);
  const locations = ALL_LOCATIONS.filter(l => l.name !== currentLocation);

  const scroll = (dir) => {
    if (!trackRef.current) return;
    trackRef.current.scrollBy({ left: dir * 300, behavior: "smooth" });
  };

  return (
    <section style={{ backgroundColor: "#F7F7F7", padding: "64px clamp(20px, 5vw, 80px)" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 28 }}>
          <div>
            <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#888", marginBottom: 8, marginTop: 0 }}>Our Locations</p>
            <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(22px, 2.5vw, 30px)", color: "#1A1A1A", margin: 0, letterSpacing: "-0.02em" }}>We also manage in…</h2>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button
              onClick={() => scroll(-1)}
              style={{ width: 40, height: 40, borderRadius: "50%", border: "1.5px solid #E5E5E5", background: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", transition: "border-color 0.2s" }}
              onMouseEnter={e => e.currentTarget.style.borderColor = "#1A1A1A"}
              onMouseLeave={e => e.currentTarget.style.borderColor = "#E5E5E5"}
            >
              <ChevronLeft size={18} color="#1A1A1A" />
            </button>
            <button
              onClick={() => scroll(1)}
              style={{ width: 40, height: 40, borderRadius: "50%", border: "1.5px solid #E5E5E5", background: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", transition: "border-color 0.2s" }}
              onMouseEnter={e => e.currentTarget.style.borderColor = "#1A1A1A"}
              onMouseLeave={e => e.currentTarget.style.borderColor = "#E5E5E5"}
            >
              <ChevronRight size={18} color="#1A1A1A" />
            </button>
          </div>
        </div>

        {/* Slider with edge gradients */}
        <div style={{ position: "relative" }}>
          <div className="gradient-left" style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 60, background: "linear-gradient(to right, #F7F7F7 0%, transparent 100%)", zIndex: 2, pointerEvents: "none" }} />
          <div className="gradient-right" style={{ position: "absolute", right: 0, top: 0, bottom: 0, width: 60, background: "linear-gradient(to left, #F7F7F7 0%, transparent 100%)", zIndex: 2, pointerEvents: "none" }} />
          <div
            ref={trackRef}
            style={{ display: "flex", gap: 16, overflowX: "auto", scrollbarWidth: "none", msOverflowStyle: "none", paddingBottom: 4 }}
          >
            <style>{`
              .locs-track::-webkit-scrollbar { display: none; }
              @media (max-width: 768px) {
                .gradient-left, .gradient-right { width: 20px !important; }
                .location-card { height: 160px !important; }
              }
            `}</style>
            {locations.map((loc) => (
              <Link
                key={loc.name}
                to={loc.path}
                className="location-card"
                style={{
                  flexShrink: 0,
                  width: 220,
                  height: 220,
                  borderRadius: 16,
                  overflow: "hidden",
                  textDecoration: "none",
                  position: "relative",
                  display: "block",
                  transition: "transform 0.2s, box-shadow 0.2s",
                }}
                onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 12px 32px rgba(0,0,0,0.18)"; }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow = "none"; }}
              >
                <img src={loc.image} alt={loc.name === "Manchester" ? "Manchester city skyline with Kimpton Clocktower Hotel - Truestays Airbnb management" : `${loc.name} cityscape - Truestays Airbnb management in ${loc.name}`} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} loading="lazy" decoding="async" />
                <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.1) 55%, transparent 100%)" }} />
                <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, padding: "16px 18px" }}>
                  <p style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 15, color: "#fff", margin: 0, letterSpacing: "-0.01em" }}>{loc.name}</p>
                  <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.75)", margin: "3px 0 0" }}>View →</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}